/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  useEffect,
  useState,
} from 'react'

import { getDay } from 'date-fns'
import { Helmet } from 'react-helmet'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'

import {
  KTSVG,
  toAbsoluteUrl
} from '../../../_metronic/helpers'

import LoadingBar from 'app/modules/loading/LoadingBar'
import LoadingBranch from 'app/modules/loading/LoadingBranch'
import LoadingSquare from 'app/modules/loading/LoadingSquare'
import LoadingSquares from 'app/modules/loading/LoadingSquares'

import CreatePackage from './CreatePackage'
import CreateSchedule from './CreateSchedule'

import {
  fetchBranches,
} from 'app/services/branches'


import {
  calculateDates,
} from 'app/services/dates'

import {
  MenuComponent,
} from '../../../_metronic/assets/ts/components'
import CheckInDayUseModal from '../DayUse/CheckInDayUseModal'
import CreateSignature from './CreateSignature'
import { LessonList } from '../Lessons/LessonList'

const CompanyPage = () => {
  const { branches } = useSelector((state : any) => ({
    branches: state.branches,
  }), shallowEqual);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams<{ slug?: string; '*': string }>();
  const branchSlugFromRoute = params?.slug;
  const basePath = branchSlugFromRoute ? `/unidade/${branchSlugFromRoute}` : '';
  const homePath = basePath || '/';
  const effectivePath = branchSlugFromRoute
    ? (params?.['*'] ? `/${params['*']}` : '/')
    : location.pathname;

  const [branch, setBranch] = useState<any>({});

  const [showBranches, setShowBranches] = useState(false);
  const [startAt, setStartAt] = useState('');
  const [finishAt, setFinishAt] = useState('');
  const [selectedDate, setSelectedDate] = useState<any>('');
  const [dates, setDates] = useState<any>([]);
  const [seeMoreTags, setSeeMoreTags] = useState<any>(false);
  const [openCheckInDayUseModal, setOpenCheckInDayUseModal] = useState(false);

  useEffect(() => {
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify({ type: 'app-modal-open' }))
    }
    return () => {
      if ((window as any).ReactNativeWebView) {
        (window as any).ReactNativeWebView.postMessage(JSON.stringify({ type: 'app-modal-close' }))
      }
    }
  }, []);

  const getIcon = (tag) => {
    let icon = 'question';

    if (tag === 'parking') { icon = 'parking'; }
    if (tag === 'shower') { icon = 'shower'; }
    if (tag === 'pub') { icon = 'signboard'; }
    if (tag === 'education') { icon = 'education'; }
    if (tag === 'class') { icon = 'education'; }
    if (tag === 'grill') { icon = 'grill'; }
    if (tag === 'restaurant') { icon = 'restaurant'; }
    if (tag === 'events') { icon = 'confetti'; }
    if (tag === 'rent_equipaments') { icon = 'equipaments'; }
    if (tag === 'referee') { icon = 'referee'; }
    if (tag === 'day_use') { icon = 'tickets'; }
    if (tag === 'playground') { icon = 'playground'; }

    return icon;
  }

  const getTag = (tag) => {
    if (tag === 'parking') { tag = 'Estacionamento'; }
    if (tag === 'shower') { tag = 'Vestiário'; }
    if (tag === 'pub') { tag = 'Bar'; }
    if (tag === 'education') { tag = 'Escolinha e clubinho'; }
    if (tag === 'class') { tag = 'Aulas grupo ou avulso'; }
    if (tag === 'grill') { tag = 'Churrasqueira'; }
    if (tag === 'restaurant') { tag = 'Restaurante ou lanchonete'; }
    if (tag === 'events') { tag = 'Eventos e festas'; }
    if (tag === 'rent_equipaments') { tag = 'Locação de equipamentos'; }
    if (tag === 'referee') { tag = 'Árbitro'; }
    if (tag === 'day_use') { tag = 'Day use'; }
    if (tag === 'playground') { tag = 'Espaço kids'; }

    return tag;
  }

  const permitedServices: Array<string> = [
    'reservation',
    'day_use',
    'reservation_credit_purchase',
    'class_credit_purchase',
    'signature',
    'lessons',
  ];

  const getServiceName = (service) => {
    if (service === 'reservation') { service = 'Locação de quadra'; }
    if (service === 'day_use') { service = 'Day use'; }
    if (service === 'reservation_credit_purchase') { service = 'Pacotes de créditos'; }
    if (service === 'signature') { service = 'Clubinho'; }
    if (service === 'class_credit_purchase') { service = 'Pacotes de aulas'; }
    if (service === 'lessons') { service = 'Grade de aulas'; }

    return service;
  }

  const getServiceDescription = (service) => {
    if (service === 'reservation') { service = 'Pague com cartão de crédito, pix ou créditos'; }
    if (service === 'day_use') { service = 'Venha se divertir pagando um preço único'; }
    if (service === 'reservation_credit_purchase') { service = 'Compre créditos para locação com desconto'; }
    if (service === 'signature') { service = 'Adquira sua assinatura e jogue quando quiser'; }
    if (service === 'class_credit_purchase') { service = 'Compre pacotes de aulas com desconto'; }
    if (service === 'lessons') { service = 'Veja as próximas aulas e use seu crédito de reposição'; }

    return service;
  }

  const getLabel = (weekday) => {
    let label = 'Domingo';

    if (weekday === 1) { label = 'Segunda'; }
    if (weekday === 2) { label = 'Terça'; }
    if (weekday === 3) { label = 'Quarta'; }
    if (weekday === 4) { label = 'Quinta'; }
    if (weekday === 5) { label = 'Sexta'; }
    if (weekday === 6) { label = 'Sábado'; }

    return label;
  }

  const getServicePath = (service) => {
    if (service === 'reservation') return '/locacao-de-quadras';
    if (service === 'day_use') return '/day-use';
    if (service === 'reservation_credit_purchase') return '/pacotes-de-creditos';
    if (service === 'class_credit_purchase') return '/pacotes-de-aulas';
    if (service === 'signature') return '/clubinho';
    if (service === 'lessons') return '/aulas';
    return '';
  }

  const isServicePath = (service) => {
    const path = getServicePath(service);

    return path !== '' && (effectivePath === path || effectivePath.startsWith(`${path}/`));
  }

  const goToService = (service, goTo = true) => {
    const path = getServicePath(service);
    const fullPath = basePath ? `${basePath}${path}` : path;

    if (goTo) {
      navigate(fullPath);
    }

    return fullPath;
  }

  useEffect(() => {
    let branchSlug = branchSlugFromRoute || window.location.hostname.split('.')[0];

    if (!branchSlugFromRoute && process.env.NODE_ENV === 'development') {
      branchSlug = 'sharx';
    }

    dispatch<any>(fetchBranches(branchSlug));

    let getDates = calculateDates();

    setDates(getDates);
    setSelectedDate(getDates[0]);

    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 1000)
  }, [branchSlugFromRoute]);

  useEffect(() => {
    if(branches.entities.length > 0) {
      if (branches.entities.length === 1) {
        setBranch(branches.entities[0]);

        let day = getDay(new Date());

        branches.entities[0].attributes.business_hours.map((item) => {
          if (item.weekday === day) {
            setStartAt(item.start_at);
            setFinishAt(item.finish_at);
          }
        });
      } else {
        setShowBranches(true);
      }
    }

    if (branches.entities.length === 0 && branches.error) {
      navigate('/home', { state: { unitUnavailable: true } });
    }
  }, [branches]);

  const isMobile = localStorage.getItem('is-mobile') === 'true'

  return (
    <>
    {branch?.attributes?.name && <Helmet>
      <title>{branch?.attributes?.name} - Atacante App</title>
    </Helmet>}

    {isMobile && (
      <span
        className="btn btn-md btn-icon btn-bg-light btn-active-color-primary w-100px h-40px cursor-pointer mb-5"
        onClick={() => navigate('/')}
      >
        <i className="las la-arrow-left fw-bold fs-2 text-primary me-3" />
        Voltar
      </span>
    )}

    <div className='card mb-5 mb-xl-10'>
      <div className='card-body pb-0'>
        {effectivePath === '/' && <div className='d-flex flex-wrap flex-sm-nowrap mb-3 pt-9 '>
          <div className='me-7 mb-4'>
            <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
              {branch && branch.attributes && branch.attributes.photo && <img src={branch.attributes.photo} alt='Logo Image' />}
              {/*<img src="https://sansiro.s3.amazonaws.com/hawaii-tennis-e-beach-tennis.jpeg" alt='Metornic' />*/}
              {/*<img src="https://sansiro.s3.amazonaws.com/default/football.png" alt='Metornic' />*/}
              {false && branch && branch.attributes && branch.attributes.is_open && <div className='position-absolute translate-middle top-0 start-100 mb-6 bg-success rounded-circle border border-2 border-white h-20px w-20px pulse-primary'></div>}
            </div>
          </div>

          <div className='flex-grow-1'>
            <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
              {!branches.listLoading && branch?.id && <div className='d-flex flex-column'>

                {/* <img src="https://res.cloudinary.com/lptennis/image/upload/c_fit,h_420,q_auto,w_1260/v1672249876/q017akdvtahtbocjq3k2.jpg" */}
                <div className='d-flex align-items-center mb-2'>
                  <span className='text-gray-800 text-hover-primary fs-1 fw-bolder me-1'>
                    {branch && branch.attributes && branch.attributes.name}
                  </span>
                  {branch && branch.attributes && branch.attributes.verified && <a href='#'>
                    <KTSVG
                      path='/media/icons/duotune/general/gen026.svg'
                      className='svg-icon-1 svg-icon-primary'
                    />
                  </a>}
                </div>

                <div className='flex-row-fluid fw-bold fs-6 mb-4 pe-2'>
                  <span className='d-flex align-items-center text-white text-hover-primary me-5 mb-2'>
                    <KTSVG
                      path='/media/icons/duotune/general/gen018.svg'
                      className='svg-icon-4 me-1'
                    />
                    {branch && branch.attributes && branch.attributes.address}
                  </span>

                  <button
                    type='button'
                    className='btn btn-outline btn-active-light my-3'
                    data-kt-menu='true'
                    data-kt-menu-trigger='click'
                    data-kt-menu-placement='bottom-end'
                    data-kt-menu-flip='bottom-end'
                  >
                    {branch && branch.attributes && <>
                      <span className={branch.attributes.is_open ? 'text-primary' : 'text-danger'}>
                        {branch.attributes.is_open ? `Aberto` : `Fechado`}
                      </span>
                      <span className='text-white'> • {startAt} até {finishAt}</span>
                      <i className="las la-angle-down fs-3 text-white ms-3"></i>
                    </>}
                  </button>

                  <div className='menu menu-sub menu-sub-dropdown w-300px w-md-325px bg-light mt-3 right-0' data-kt-menu='true'>
                    <div className='px-10 py-4'>
                      <div className='fs-5 text-dark fw-bolder'>Horário de funcionamento</div>
                    </div>

                    <div className='separator border-1 border-gray-300'></div>

                    <div className='px-10 pt-3 pb-6' data-kt-user-table-filter='form'>
                      <div className='row d-flex'>
                        {branch && branch.attributes && branch.attributes.business_hours.map((day) => {
                          return (<div className="col-6 d-flex flex-wrap flex-column mt-3">
                            <span className="fs-8 fd-uppercase text-gray-800">{getLabel(day.weekday)}</span>
                            <span className="fs-7 fd-uppercase text-white">{day.start_at} ~ {day.finish_at}</span>
                          </div>);
                        })}
                      </div>
                    </div>
                  </div>

                  {branch && branch.attributes && <a href={`https://wa.me/${branch.attributes.phone}`} target="_blank" rel="noreferrer">
                    <span className='d-flex align-items-center text-white text-hover-primary mt-5 me-5 fs-5'>
                      {branch.attributes.phone}
                      <img
                        src={toAbsoluteUrl(`/media/custom/whatsapp.png`)}
                        height="24"
                        width="24"
                        alt='Estacionamento'
                        className="icon-flag text-hover-primary ms-4"
                      />
                    </span>
                  </a>}
                </div>
              </div>}

              {branches.listLoading && !branch?.id && <div className='d-flex flex-column'>
                <LoadingBranch />
              </div>}
            </div>
          </div>
        </div>}

        {
          (
            effectivePath === '/locacao-de-quadras' ||
            effectivePath === '/day-use' ||
            effectivePath === '/clubinho' ||
            effectivePath === '/pacotes-de-creditos' ||
            effectivePath === '/pacotes-de-aulas' ||
            effectivePath === '/aulas'
          ) &&
          branch?.attributes && <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold'>
          <li className='nav-item mt-2'>
            <Link
              className={`nav-link text-active-primary ms-0 me-10 py-5`}
              to={homePath}
            >
              Início
            </Link>
          </li>

          {branch?.attributes?.services?.filter((service: string) => permitedServices.includes(service)).map(service => <li className='nav-item mt-2'>
            <span
              className={
                `nav-link text-active-primary ms-0 me-10 py-5 cursor-pointer ` +
                (isServicePath(service) && 'active')
              }
              onClick={() => goToService(service)}
            >
              {getServiceName(service)}
            </span>
          </li>)}
        </ul>}
      </div>
    </div>

    {effectivePath === '/locacao-de-quadras' && <CreateSchedule
      branch={branch}
    />}

    {effectivePath == '/clubinho111' && <div className='card mb-5 mb-xl-10'>
      <div className='card-body pt-9 pb-0'>
        <div className="mb-13 text-center">
          {branch?.attributes?.name && <h1 className="mb-3">
            Jogue quando quiser no {branch?.attributes?.name}!
          </h1>}
          <div className="text-muted fw-semibold fs-5">
            Venha participar do clubinho, você pode jogar todos os dias da semana!
          </div>
        </div>
        <div className="d-flex flex-column">
          {/*<div className="nav-group nav-group-outline mx-auto" data-kt-buttons="true">
            <button className="btn btn-color-gray-400 btn-active btn-active-secondary px-6 py-3 me-2 active" data-kt-plan="month">Monthly</button>
            <button className="btn btn-color-gray-400 btn-active btn-active-secondary px-6 py-3" data-kt-plan="annual">Annual</button>
          </div>*/}
          <div className="row mt-10">
            <div className="col-lg-6 mb-10 mb-lg-0">
              <div className="nav flex-column">
                <label className="nav-link btn btn-outline btn-outline-dashed btn-color-dark btn-active btn-active-primary d-flex flex-stack text-start p-6 active mb-6" data-bs-toggle="tab" data-bs-target="#kt_upgrade_plan_startup">
                  <div className="d-flex align-items-center me-2">
                    <div className="form-check form-check-custom form-check-solid form-check-success flex-shrink-0 me-6">
                      <input className="form-check-input" type="radio" name="plan" checked={true} value="startup" />
                    </div>
                    <div className="flex-grow-1">
                      <div className="d-flex align-items-center fs-2 fw-bold flex-wrap">Beach tennis - mensal</div>
                      <div className="fw-semibold opacity-75">4 quadras dísponiveis todos os dias</div>
                    </div>
                  </div>
                  <div className="ms-5">
                    <span className="mb-2">R$</span>
                    <span className="fs-3x fw-bold" data-kt-plan-price-month="39" data-kt-plan-price-annual="399">139</span>
                    <span className="fs-7 opacity-50">/
                    <span data-kt-element="period">Mês</span></span>
                  </div>
                </label>
                <label className="nav-link btn btn-outline btn-outline-dashed btn-color-dark btn-active btn-active-primary d-flex flex-stack text-start p-6 mb-6" data-bs-toggle="tab" data-bs-target="#kt_upgrade_plan_advanced">
                  <div className="d-flex align-items-center me-2">
                    <div className="form-check form-check-custom form-check-solid form-check-success flex-shrink-0 me-6">
                      <input className="form-check-input" type="radio" name="plan" value="advanced" />
                    </div>
                    <div className="flex-grow-1">
                      <div className="d-flex align-items-center fs-2 fw-bold flex-wrap">Beach tennis - trimestral</div>
                      <div className="fw-semibold opacity-75">Com 10% OFF para pagamentos trimestral</div>
                    </div>
                  </div>
                  <div className="ms-5">
                    <span className="mb-2">R$</span>
                    <span className="fs-3x fw-bold" data-kt-plan-price-month="339" data-kt-plan-price-annual="3399">351</span>
                    <span className="fs-7 opacity-50">/
                    <span data-kt-element="period">3 meses</span></span>
                  </div>
                </label>
                <label className="nav-link btn btn-outline btn-outline-dashed btn-color-dark btn-active btn-active-primary d-flex flex-stack text-start p-6 mb-6" data-bs-toggle="tab" data-bs-target="#kt_upgrade_plan_enterprise">
                  <div className="d-flex align-items-center me-2">
                    <div className="form-check form-check-custom form-check-solid form-check-success flex-shrink-0 me-6">
                      <input className="form-check-input" type="radio" name="plan" value="enterprise" />
                    </div>
                    <div className="flex-grow-1">
                      <div className="d-flex align-items-center fs-2 fw-bold flex-wrap">Beach tennis - anual
                      <span className="badge badge-light-success ms-2 py-2 px-3 fs-7">Mais vendido</span></div>
                      <div className="fw-semibold opacity-75">Jogue por um ano com 25% OFF</div>
                    </div>
                  </div>
                  <div className="ms-5">
                    <span className="mb-2">R$</span>
                    <span className="fs-3x fw-bold" data-kt-plan-price-month="999" data-kt-plan-price-annual="9999">1251</span>
                    <span className="fs-7 opacity-50">/
                    <span data-kt-element="period">Anual</span></span>
                  </div>
                </label>
                {/*<label className="nav-link btn btn-outline btn-outline-dashed btn-color-dark btn-active btn-active-primary d-flex flex-stack text-start p-6 mb-6" data-bs-toggle="tab" data-bs-target="#kt_upgrade_plan_custom">
                  <div className="d-flex align-items-center me-2">
                    <div className="form-check form-check-custom form-check-solid form-check-success flex-shrink-0 me-6">
                      <input className="form-check-input" type="radio" name="plan" value="custom" />
                    </div>
                    <div className="flex-grow-1">
                      <div className="d-flex align-items-center fs-2 fw-bold flex-wrap">Custom</div>
                      <div className="fw-semibold opacity-75">Requet a custom license</div>
                    </div>
                  </div>
                  <div className="ms-5">
                    <a href="#" className="btn btn-sm btn-success">Contact Us</a>
                  </div>
                </label>*/}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="tab-content rounded h-100 bg-light p-10">
                <div className="tab-pane fade show active" id="kt_upgrade_plan_startup">
                  <div className="pb-5">
                    <h2 className="fw-bold text-dark">What’s in Startup Plan?</h2>
                    <div className="text-muted fw-semibold">Optimal for 10+ team size and new startup</div>
                  </div>
                  <div className="pt-1">
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-gray-700 flex-grow-1">Up to 10 Active Users</span>
                      <span className="svg-icon svg-icon-1 svg-icon-success">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-gray-700 flex-grow-1">Up to 30 Project Integrations</span>
                      <span className="svg-icon svg-icon-1 svg-icon-success">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-gray-700 flex-grow-1">Analytics Module</span>
                      <span className="svg-icon svg-icon-1 svg-icon-success">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-muted flex-grow-1">Finance Module</span>
                      <span className="svg-icon svg-icon-1">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor" />
                          <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-muted flex-grow-1">Accounting Module</span>
                      <span className="svg-icon svg-icon-1">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor" />
                          <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-muted flex-grow-1">Network Platform</span>
                      <span className="svg-icon svg-icon-1">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor" />
                          <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center">
                      <span className="fw-semibold fs-5 text-muted flex-grow-1">Unlimited Cloud Space</span>
                      <span className="svg-icon svg-icon-1">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor" />
                          <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="kt_upgrade_plan_advanced">
                  <div className="pb-5">
                    <h2 className="fw-bold text-dark">What’s in Startup Plan?</h2>
                    <div className="text-muted fw-semibold">Optimal for 100+ team size and grown company</div>
                  </div>
                  <div className="pt-1">
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-gray-700 flex-grow-1">Up to 10 Active Users</span>
                      <span className="svg-icon svg-icon-1 svg-icon-success">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-gray-700 flex-grow-1">Up to 30 Project Integrations</span>
                      <span className="svg-icon svg-icon-1 svg-icon-success">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-gray-700 flex-grow-1">Analytics Module</span>
                      <span className="svg-icon svg-icon-1 svg-icon-success">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-gray-700 flex-grow-1">Finance Module</span>
                      <span className="svg-icon svg-icon-1 svg-icon-success">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-gray-700 flex-grow-1">Accounting Module</span>
                      <span className="svg-icon svg-icon-1 svg-icon-success">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-muted flex-grow-1">Network Platform</span>
                      <span className="svg-icon svg-icon-1">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor" />
                          <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center">
                      <span className="fw-semibold fs-5 text-muted flex-grow-1">Unlimited Cloud Space</span>
                      <span className="svg-icon svg-icon-1">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor" />
                          <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="kt_upgrade_plan_enterprise">
                  <div className="pb-5">
                    <h2 className="fw-bold text-dark">What’s in Startup Plan?</h2>
                    <div className="text-muted fw-semibold">Optimal for 1000+ team and enterpise</div>
                  </div>
                  <div className="pt-1">
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-gray-700 flex-grow-1">Up to 10 Active Users</span>
                      <span className="svg-icon svg-icon-1 svg-icon-success">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-gray-700 flex-grow-1">Up to 30 Project Integrations</span>
                      <span className="svg-icon svg-icon-1 svg-icon-success">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-gray-700 flex-grow-1">Analytics Module</span>
                      <span className="svg-icon svg-icon-1 svg-icon-success">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-gray-700 flex-grow-1">Finance Module</span>
                      <span className="svg-icon svg-icon-1 svg-icon-success">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-gray-700 flex-grow-1">Accounting Module</span>
                      <span className="svg-icon svg-icon-1 svg-icon-success">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-gray-700 flex-grow-1">Network Platform</span>
                      <span className="svg-icon svg-icon-1 svg-icon-success">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center">
                      <span className="fw-semibold fs-5 text-gray-700 flex-grow-1">Unlimited Cloud Space</span>
                      <span className="svg-icon svg-icon-1 svg-icon-success">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="kt_upgrade_plan_custom">
                  <div className="pb-5">
                    <h2 className="fw-bold text-dark">What’s in Startup Plan?</h2>
                    <div className="text-muted fw-semibold">Optimal for corporations</div>
                  </div>
                  <div className="pt-1">
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-gray-700 flex-grow-1">Unlimited Users</span>
                      <span className="svg-icon svg-icon-1 svg-icon-success">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-gray-700 flex-grow-1">Unlimited Project Integrations</span>
                      <span className="svg-icon svg-icon-1 svg-icon-success">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-gray-700 flex-grow-1">Analytics Module</span>
                      <span className="svg-icon svg-icon-1 svg-icon-success">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-gray-700 flex-grow-1">Finance Module</span>
                      <span className="svg-icon svg-icon-1 svg-icon-success">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-gray-700 flex-grow-1">Accounting Module</span>
                      <span className="svg-icon svg-icon-1 svg-icon-success">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-7">
                      <span className="fw-semibold fs-5 text-gray-700 flex-grow-1">Network Platform</span>
                      <span className="svg-icon svg-icon-1 svg-icon-success">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex align-items-center">
                      <span className="fw-semibold fs-5 text-gray-700 flex-grow-1">Unlimited Cloud Space</span>
                      <span className="svg-icon svg-icon-1 svg-icon-success">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                          <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex flex-center flex-row-fluid pb-15">
          {/*<button type="reset" className="btn btn-light me-3" data-bs-dismiss="modal">Cancel</button>
          <button type="submit" className="btn btn-primary" id="kt_modal_upgrade_plan_btn">
            <span className="indicator-label">Upgrade Plan</span>
            <span className="indicator-progress">Please wait...
            <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>
          </button>*/}
        </div>
      </div>
    </div>}

    {effectivePath == '/day-use1111' && <>
      <div id="kt_app_content" className="flex-column-fluid">
        <div id="kt_app_content_container">
          <div className="d-flex flex-column flex-lg-row">
            <div className="flex-lg-row-fluid mb-10 mb-lg-0 me-xl-10">
              <div className="card">
                <div className='card-body pt-12'>
                  <div className="mb-13 text-center">
                    {branch?.attributes?.name && <h1 className="mb-3">
                      Venha passar o dia e jogar avontade no {branch?.attributes?.name}
                    </h1>}
                    <div className="text-muted fw-semibold fs-5">
                      Para comprar um day use é muito fácil basta selecionar o dia que vai jogar,
                    </div>
                    <div className="text-muted fw-semibold fs-5">
                      escolher um plano e comprar!
                    </div>
                  </div>

                  <ul className="nav nav-pills d-flex flex-nowrap hover-scroll-x py-2">
                    <li className="nav-item me-1">
                      <a className="nav-link btn d-flex flex-column flex-center rounded-pill min-w-40px me-2 py-4 btn-active-primary" data-bs-toggle="tab" href="#kt_schedule_day_0">
                        <span className="opacity-50 fs-7 fw-semibold">Hoje</span>
                        <span className="fs-6 fw-bolder">21</span >
                      </a>
                    </li>
                    <li className="nav-item me-1">
                      <a className="nav-link btn d-flex flex-column flex-center rounded-pill min-w-40px me-2 py-4 btn-active-primary active" data-bs-toggle="tab" href="#kt_schedule_day_1">
                        <span className="opacity-50 fs-7 fw-semibold">Ter</span>
                        <span className="fs-6 fw-bolder">22</span>
                      </a>
                    </li>
                    <li className="nav-item me-1">
                      <a className="nav-link btn d-flex flex-column flex-center rounded-pill min-w-40px me-2 py-4 btn-active-primary" data-bs-toggle="tab" href="#kt_schedule_day_2">
                        <span className="opacity-50 fs-7 fw-semibold">Qua</span>
                        <span className="fs-6 fw-bolder">23</span>
                      </a>
                    </li>
                    <li className="nav-item me-1">
                      <a className="nav-link btn d-flex flex-column flex-center rounded-pill min-w-40px me-2 py-4 btn-active-primary" data-bs-toggle="tab" href="#kt_schedule_day_3">
                        <span className="opacity-50 fs-7 fw-semibold">Qui</span>
                        <span className="fs-6 fw-bolder">24</span>
                      </a>
                    </li>
                    <li className="nav-item me-1">
                      <a className="nav-link btn d-flex flex-column flex-center rounded-pill min-w-40px me-2 py-4 btn-active-primary" data-bs-toggle="tab" href="#kt_schedule_day_4">
                        <span className="opacity-50 fs-7 fw-semibold">Sex</span>
                        <span className="fs-6 fw-bolder">25</span>
                      </a>
                    </li>
                    <li className="nav-item me-1">
                      <a className="nav-link btn d-flex flex-column flex-center rounded-pill min-w-40px me-2 py-4 btn-active-primary" data-bs-toggle="tab" href="#kt_schedule_day_5">
                        <span className="opacity-50 fs-7 fw-semibold">Sab</span>
                        <span className="fs-6 fw-bolder">26</span>
                      </a>
                    </li>
                    <li className="nav-item me-1">
                      <a className="nav-link btn d-flex flex-column flex-center rounded-pill min-w-40px me-2 py-4 btn-active-primary" data-bs-toggle="tab" href="#kt_schedule_day_6">
                        <span className="opacity-50 fs-7 fw-semibold">Dom</span>
                        <span className="fs-6 fw-bolder">27</span>
                      </a>
                    </li>
                    <li className="nav-item me-1">
                      <a className="nav-link btn d-flex flex-column flex-center rounded-pill min-w-40px me-2 py-4 btn-active-primary" data-bs-toggle="tab" href="#kt_schedule_day_7">
                        <span className="opacity-50 fs-7 fw-semibold">Seg</span>
                        <span className="fs-6 fw-bolder">28</span>
                      </a>
                    </li>
                    <li className="nav-item me-1">
                      <a className="nav-link btn d-flex flex-column flex-center rounded-pill min-w-40px me-2 py-4 btn-active-primary" data-bs-toggle="tab" href="#kt_schedule_day_8">
                        <span className="opacity-50 fs-7 fw-semibold">Ter</span>
                        <span className="fs-6 fw-bolder">29</span>
                      </a>
                    </li>
                    <li className="nav-item me-1">
                      <a className="nav-link btn d-flex flex-column flex-center rounded-pill min-w-40px me-2 py-4 btn-active-primary" data-bs-toggle="tab" href="#kt_schedule_day_9">
                        <span className="opacity-50 fs-7 fw-semibold">Qua</span>
                        <span className="fs-6 fw-bolder">30</span>
                      </a>
                    </li>
                    <li className="nav-item me-1">
                      <a className="nav-link btn d-flex flex-column flex-center rounded-pill min-w-40px me-2 py-4 btn-active-primary" data-bs-toggle="tab" href="#kt_schedule_day_10">
                        <span className="opacity-50 fs-7 fw-semibold">Qui</span>
                        <span className="fs-6 fw-bolder">31</span>
                      </a>
                    </li>
                    <li className="nav-item me-1">
                      <a className="nav-link btn d-flex flex-column flex-center rounded-pill min-w-40px me-2 py-4 btn-active-primary" data-bs-toggle="tab" href="#kt_schedule_day_10">
                        <span className="opacity-50 fs-7 fw-semibold">Sex</span>
                        <span className="fs-6 fw-bolder">31</span>
                      </a>
                    </li>
                    <li className="nav-item me-1">
                      <a className="nav-link btn d-flex flex-column flex-center rounded-pill min-w-40px me-2 py-4 btn-active-primary" data-bs-toggle="tab" href="#kt_schedule_day_10">
                        <span className="opacity-50 fs-7 fw-semibold">We</span>
                        <span className="fs-6 fw-bolder">31</span>
                      </a>
                    </li>
                    <li className="nav-item me-1">
                      <a className="nav-link btn d-flex flex-column flex-center rounded-pill min-w-40px me-2 py-4 btn-active-primary" data-bs-toggle="tab" href="#kt_schedule_day_10">
                        <span className="opacity-50 fs-7 fw-semibold">We</span>
                        <span className="fs-6 fw-bolder">31</span>
                      </a>
                    </li>
                    <li className="nav-item me-1">
                      <a className="nav-link btn d-flex flex-column flex-center rounded-pill min-w-40px me-2 py-4 btn-active-primary" data-bs-toggle="tab" href="#kt_schedule_day_10">
                        <span className="opacity-50 fs-7 fw-semibold">We</span>
                        <span className="fs-6 fw-bolder">31</span>
                      </a>
                    </li>
                  </ul>

                  <div className="d-flex flex-column">
                    {/*<div className="nav-group nav-group-outline mx-auto" data-kt-buttons="true">
                      <button className="btn btn-color-gray-400 btn-active btn-active-secondary px-6 py-3 me-2 active" data-kt-plan="month">Monthly</button>
                      <button className="btn btn-color-gray-400 btn-active btn-active-secondary px-6 py-3" data-kt-plan="annual">Annual</button>
                    </div>*/}
                    <div className="row mt-10">
                      <div className="col-lg-12 mb-10 mb-lg-0">
                        <div className="nav flex-column">
                          <label className="nav-link btn btn-outline btn-outline-dashed btn-color-dark btn-active btn-active-primary d-flex flex-stack text-start p-6 active mb-6" data-bs-toggle="tab" data-bs-target="#kt_upgrade_plan_startup">
                            <div className="d-flex align-items-center me-2">
                              <div className="form-check form-check-custom form-check-solid form-check-success flex-shrink-0 me-6">
                                <input className="form-check-input" type="radio" name="plan" checked={true} value="startup" />
                              </div>
                              <div className="flex-grow-1">
                                <div className="d-flex align-items-center fs-2 fw-bold flex-wrap">Beach tennis - mensal</div>
                                <div className="fw-semibold opacity-75">4 quadras dísponiveis todos os dias</div>
                              </div>
                            </div>
                            <div className="ms-5">
                              <span className="mb-2">R$</span>
                              <span className="fs-3x fw-bold" data-kt-plan-price-month="39" data-kt-plan-price-annual="399">139</span>
                              <span className="fs-7 opacity-50">/
                              <span data-kt-element="period">Mês</span></span>
                            </div>
                          </label>
                          <label className="nav-link btn btn-outline btn-outline-dashed btn-color-dark btn-active btn-active-primary d-flex flex-stack text-start p-6 mb-6" data-bs-toggle="tab" data-bs-target="#kt_upgrade_plan_advanced">
                            <div className="d-flex align-items-center me-2">
                              <div className="form-check form-check-custom form-check-solid form-check-success flex-shrink-0 me-6">
                                <input className="form-check-input" type="radio" name="plan" value="advanced" />
                              </div>
                              <div className="flex-grow-1">
                                <div className="d-flex align-items-center fs-2 fw-bold flex-wrap">Beach tennis - trimestral</div>
                                <div className="fw-semibold opacity-75">Com 10% OFF para pagamentos trimestral</div>
                              </div>
                            </div>
                            <div className="ms-5">
                              <span className="mb-2">R$</span>
                              <span className="fs-3x fw-bold" data-kt-plan-price-month="339" data-kt-plan-price-annual="3399">351</span>
                              <span className="fs-7 opacity-50">/
                              <span data-kt-element="period">3 meses</span></span>
                            </div>
                          </label>
                          <label className="nav-link btn btn-outline btn-outline-dashed btn-color-dark btn-active btn-active-primary d-flex flex-stack text-start p-6 mb-6" data-bs-toggle="tab" data-bs-target="#kt_upgrade_plan_enterprise">
                            <div className="d-flex align-items-center me-2">
                              <div className="form-check form-check-custom form-check-solid form-check-success flex-shrink-0 me-6">
                                <input className="form-check-input" type="radio" name="plan" value="enterprise" />
                              </div>
                              <div className="flex-grow-1">
                                <div className="d-flex align-items-center fs-2 fw-bold flex-wrap">Beach tennis - anual
                                <span className="badge badge-light-success ms-2 py-2 px-3 fs-7">Mais vendido</span></div>
                                <div className="fw-semibold opacity-75">Jogue por um ano com 25% OFF</div>
                              </div>
                            </div>
                            <div className="ms-5">
                              <span className="mb-2">R$</span>
                              <span className="fs-3x fw-bold" data-kt-plan-price-month="999" data-kt-plan-price-annual="9999">1251</span>
                              <span className="fs-7 opacity-50">/
                              <span data-kt-element="period">Anual</span></span>
                            </div>
                          </label>

                          {/**/}


                          <label className="nav-link btn btn-outline btn-outline-dashed btn-color-dark btn-active btn-active-primary d-flex flex-stack text-start p-6 mb-6" data-bs-toggle="tab" data-bs-target="#kt_upgrade_plan_advanced">
                            <div className="d-flex align-items-center me-2">
                              <div className="form-check form-check-custom form-check-solid form-check-success flex-shrink-0 me-6">
                                <input className="form-check-input" type="radio" name="plan" value="advanced" />
                              </div>
                              <div className="flex-grow-1">
                                <div className="d-flex align-items-center fs-2 fw-bold flex-wrap">Beach tennis - trimestral</div>
                                <div className="fw-semibold opacity-75">Com 10% OFF para pagamentos trimestral</div>
                              </div>
                            </div>
                            <div className="ms-5">
                              <span className="mb-2">R$</span>
                              <span className="fs-3x fw-bold" data-kt-plan-price-month="339" data-kt-plan-price-annual="3399">351</span>
                              <span className="fs-7 opacity-50">/
                              <span data-kt-element="period">3 meses</span></span>
                            </div>
                          </label>
                          <label className="nav-link btn btn-outline btn-outline-dashed btn-color-dark btn-active btn-active-primary d-flex flex-stack text-start p-6 mb-6" data-bs-toggle="tab" data-bs-target="#kt_upgrade_plan_advanced">
                            <div className="d-flex align-items-center me-2">
                              <div className="form-check form-check-custom form-check-solid form-check-success flex-shrink-0 me-6">
                                <input className="form-check-input" type="radio" name="plan" value="advanced" />
                              </div>
                              <div className="flex-grow-1">
                                <div className="d-flex align-items-center fs-2 fw-bold flex-wrap">Beach tennis - trimestral</div>
                                <div className="fw-semibold opacity-75">Com 10% OFF para pagamentos trimestral</div>
                              </div>
                            </div>
                            <div className="ms-5">
                              <span className="mb-2">R$</span>
                              <span className="fs-3x fw-bold" data-kt-plan-price-month="339" data-kt-plan-price-annual="3399">351</span>
                              <span className="fs-7 opacity-50">/
                              <span data-kt-element="period">3 meses</span></span>
                            </div>
                          </label>
                          <label className="nav-link btn btn-outline btn-outline-dashed btn-color-dark btn-active btn-active-primary d-flex flex-stack text-start p-6 mb-6" data-bs-toggle="tab" data-bs-target="#kt_upgrade_plan_advanced">
                            <div className="d-flex align-items-center me-2">
                              <div className="form-check form-check-custom form-check-solid form-check-success flex-shrink-0 me-6">
                                <input className="form-check-input" type="radio" name="plan" value="advanced" />
                              </div>
                              <div className="flex-grow-1">
                                <div className="d-flex align-items-center fs-2 fw-bold flex-wrap">Beach tennis - trimestral</div>
                                <div className="fw-semibold opacity-75">Com 10% OFF para pagamentos trimestral</div>
                              </div>
                            </div>
                            <div className="ms-5">
                              <span className="mb-2">R$</span>
                              <span className="fs-3x fw-bold" data-kt-plan-price-month="339" data-kt-plan-price-annual="3399">351</span>
                              <span className="fs-7 opacity-50">/
                              <span data-kt-element="period">3 meses</span></span>
                            </div>
                          </label>
                          <label className="nav-link btn btn-outline btn-outline-dashed btn-color-dark btn-active btn-active-primary d-flex flex-stack text-start p-6 mb-6" data-bs-toggle="tab" data-bs-target="#kt_upgrade_plan_advanced">
                            <div className="d-flex align-items-center me-2">
                              <div className="form-check form-check-custom form-check-solid form-check-success flex-shrink-0 me-6">
                                <input className="form-check-input" type="radio" name="plan" value="advanced" />
                              </div>
                              <div className="flex-grow-1">
                                <div className="d-flex align-items-center fs-2 fw-bold flex-wrap">Beach tennis - trimestral</div>
                                <div className="fw-semibold opacity-75">Com 10% OFF para pagamentos trimestral</div>
                              </div>
                            </div>
                            <div className="ms-5">
                              <span className="mb-2">R$</span>
                              <span className="fs-3x fw-bold" data-kt-plan-price-month="339" data-kt-plan-price-annual="3399">351</span>
                              <span className="fs-7 opacity-50">/
                              <span data-kt-element="period">3 meses</span></span>
                            </div>
                          </label>
                          <label className="nav-link btn btn-outline btn-outline-dashed btn-color-dark btn-active btn-active-primary d-flex flex-stack text-start p-6 mb-6" data-bs-toggle="tab" data-bs-target="#kt_upgrade_plan_advanced">
                            <div className="d-flex align-items-center me-2">
                              <div className="form-check form-check-custom form-check-solid form-check-success flex-shrink-0 me-6">
                                <input className="form-check-input" type="radio" name="plan" value="advanced" />
                              </div>
                              <div className="flex-grow-1">
                                <div className="d-flex align-items-center fs-2 fw-bold flex-wrap">Beach tennis - trimestral</div>
                                <div className="fw-semibold opacity-75">Com 10% OFF para pagamentos trimestral</div>
                              </div>
                            </div>
                            <div className="ms-5">
                              <span className="mb-2">R$</span>
                              <span className="fs-3x fw-bold" data-kt-plan-price-month="339" data-kt-plan-price-annual="3399">351</span>
                              <span className="fs-7 opacity-50">/
                              <span data-kt-element="period">3 meses</span></span>
                            </div>
                          </label>

                          {/**/}

                          {/*<label className="nav-link btn btn-outline btn-outline-dashed btn-color-dark btn-active btn-active-primary d-flex flex-stack text-start p-6 mb-6" data-bs-toggle="tab" data-bs-target="#kt_upgrade_plan_custom">
                            <div className="d-flex align-items-center me-2">
                              <div className="form-check form-check-custom form-check-solid form-check-success flex-shrink-0 me-6">
                                <input className="form-check-input" type="radio" name="plan" value="custom" />
                              </div>
                              <div className="flex-grow-1">
                                <div className="d-flex align-items-center fs-2 fw-bold flex-wrap">Custom</div>
                                <div className="fw-semibold opacity-75">Requet a custom license</div>
                              </div>
                            </div>
                            <div className="ms-5">
                              <a href="#" className="btn btn-sm btn-success">Contact Us</a>
                            </div>
                          </label>*/}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-center flex-row-fluid pb-15">
                  </div>
                </div>
              </div>
            </div>

            <div className="flex-lg-auto min-w-lg-400px">
              <div className="card card-flush pt-3 mb-0" data-kt-sticky="true" data-kt-sticky-name="invoice-2" data-kt-sticky-offset="{default: false, lg: '200px'}" data-kt-sticky-width="{lg: '250px', lg: '400px'}" data-kt-sticky-left="auto" data-kt-sticky-top="150px" data-kt-sticky-animation="false" data-kt-sticky-zindex="95">
                <div className="card-header">
                  <div className="card-title">
                    <h2>Checkout</h2>
                  </div>
                </div>
                <div className="card-body pt-0 fs-6">
                  <div className="mb-7">
                    <h5 className="mb-3">Plano</h5>
                    <div className="d-flex align-items-center mb-1">
                      <span className="fw-bold text-gray-800 text-hover-primary me-2">Day use - beach tennis</span>
                    </div>
                    <a href="#" className="fw-semibold text-gray-600 text-hover-primary">12/10/2022 das 18h até 22h</a>
                    <div className="d-flex align-items-center mb-1">
                      <span className="badge badge-light-success">Sharx - Centro</span>
                    </div>
                    <div className="d-flex align-items-center mb-1">
                      <span className="badge badge-light-success">Sharx - Parque Santa Cecilia</span>
                    </div>
                  </div>
                  <div className="separator separator-dashed mb-7"></div>
                  <div className="mb-7">
                    <h5 className="mb-3">Pagamento</h5>
                    <div className="mb-0">
                      <span className="badge badge-light-primary me-2">Pagamento único</span>
                      <span className="fw-semibold text-gray-600">R$ 35 / por pessoa</span>
                    </div>
                  </div>
                  {/*<div className="separator separator-dashed mb-7"></div>
                  <div className="mb-10">
                    <h5 className="mb-3">Payment Details</h5>
                    <div className="mb-0">
                      <div className="fw-semibold text-gray-600 d-flex align-items-center">Mastercard
                      <img src="assets/media/svg/card-logos/mastercard.svg" className="w-35px ms-2" alt="" /></div>
                      <div className="fw-semibold text-gray-600">Expires Dec 2024</div>
                    </div>
                  </div>*/}
                  <div className="mb-0">
                    <button type="button" className="btn btn-primary" id="kt_subscriptions_create_button" onClick={() => console.log(true)}>
                      <span className="indicator-label">Comprar agora!</span>
                      <span className="indicator-progress">Please wait...
                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>}

    {effectivePath === '/clubinho' && <CreateSignature
      branch={branch}
      type="plan"
    />}

    {effectivePath === '/day-use' && <CreatePackage
      branch={branch}
      type="plan"
      modality="day_use"
    />}

    {effectivePath === '/pacotes-de-creditos' && <CreatePackage
      branch={branch}
      type="service"
      modality="reservation"
    />}

    {effectivePath === '/pacotes-de-aulas' && <CreatePackage
      branch={branch}
      type="service"
      modality="class"
    />}

    {effectivePath === '/aulas' && <LessonList
      branch={branch}
    />}

    {effectivePath == '/' && <>
      <div id="kt_app_content" className="flex-column-fluid">
        <div id="kt_app_content_container">
          <div className="row">
            <div className="col-lg-8">
              <div className="card mb-5">
                <div className='card-body pt-12'>
                  <div className="mb-5 text-center">
                    {branch?.attributes?.name && <h1 className="mb-3">
                      Venha Jogar no {branch?.attributes?.name}
                    </h1>}
                    <div className="text-muted fw-semibold fs-5">
                      Escolha um serviço e pague online
                    </div>
                  </div>
                  <div className="row justify-content-md-center">
                    <div className="col-lg-10">
                      {!branches.listLoading && branch?.id && branch?.attributes?.services?.filter((service: string) => permitedServices.includes(service)).map(service => <div onClick={() => goToService(service)} className="card card-dashed flex-row flex-stack flex-wrap py-5 my-5 cursor-pointer">
                        <div className="d-flex flex-column px-7">
                            <div className="d-flex align-items-center fs-4 fw-bold mb-3">{getServiceName(service)}</div>
                            <div className="fs-5 fw-semibold text-gray-600">{getServiceDescription(service)}</div>
                            <i className="position-absolute end-0 mt-5 me-5 las la-angle-right fs-2x text-primary"></i>
                        </div>
                      </div>)}

                      {!branches.listLoading && branch?.id && branch?.attributes?.services?.includes('day_use') && <div
                        className="card card-dashed flex-row flex-stack flex-wrap py-5 my-5 cursor-pointer"
                        onClick={() => setOpenCheckInDayUseModal(true)}
                      >
                        <div className="d-flex flex-column px-7">
                            <div className="d-flex align-items-center fs-4 fw-bold mb-3">Check-in do day use</div>
                            <div className="fs-5 fw-semibold text-gray-600">Fazer check-in do seu day use</div>
                            <i className="position-absolute end-0 mt-5 me-5 las la-angle-right fs-2x text-primary"></i>
                        </div>
                      </div>}

                      {branches.listLoading && !branch?.id && <div className='flex-row flex-stack flex-wrap py-5 my-5 text-center'>
                        <LoadingBar />
                      </div>}
                    </div>
                  </div>

                  {/* {!branches.listLoading && <div className="mb-5 text-center">
                    <h2 className="mb-3">
                      Faça seu check-in
                    </h2>
                    <div className="text-muted fw-semibold fs-5">
                      Faça check-in do seu day use
                    </div>
                    <div className="row justify-content-md-center">
                      <div className="col-lg-10">
                        <div
                          className="card card-dashed flex-row flex-stack flex-wrap py-5 my-5 cursor-pointer"
                          onClick={() => setOpenCheckInDayUseModal(true)}
                        >
                          <div className="d-flex flex-column px-7">
                              <div className="d-flex align-items-center fs-4 fw-bold mb-3">Check-in do day use</div>
                              <div className="fs-5 fw-semibold text-gray-600">Fazer check-in do seu day use</div>
                              <i className="position-absolute end-0 mt-5 me-5 las la-angle-right fs-2x text-primary"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>} */}
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card">
                <div className='card-body pt-12'>
                  <div className="row justify-content-md-center">
                    <div className="col-xl-12">
                      {/*<iframe
                        height="400"
                        frameBorder="0"
                        className="w-100 border-0"
                        referrerPolicy="no-referrer-when-downgrade"
                        src={"https://www.google.com/maps/embed/v1/view?key=AIzaSyCcl908J286_GekXxwYi8hlj0bfkIWfJww&center=-23.566553,-46.650328&zoom=10"}
                      ></iframe>*/}

                      {/*<div id="kt_carousel_1_carousel"
                        className="carousel carousel-custom slide min-h-lg-250px"
                        data-bs-ride="carousel"
                        data-bs-interval="3000"
                      >
                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                          <span className="fs-4 fw-bolder pe-2">Projects</span>
                          <ol className="p-0 m-0 carousel-indicators carousel-indicators-dots">
                            <li
                              data-bs-target="#kt_carousel_1_carousel"
                              data-bs-slide-to="0"
                              className="ms-1 active"
                            ></li>
                            <li
                              data-bs-target="#kt_carousel_1_carousel"
                              data-bs-slide-to="1"
                              className="ms-1"
                            ></li>
                            <li
                              data-bs-target="#kt_carousel_1_carousel"
                              data-bs-slide-to="2"
                              className="ms-1"
                            ></li>
                          </ol>
                        </div>

                        <div className="carousel-inner pt-8">
                          <div className="carousel-item active">
                            Lorem Ipsum is simply dummy text of the printing and
                            typesetting industry. Lorem Ipsum has been the industry's
                            standard dummy text ever since the 1500s, when an unknown
                            printer took a galley of type and scrambled it to make a type
                            specimen book. It has survived not only five centuries, but
                            also the leap into electronic typesetting, remaining
                            essentially unchanged.
                          </div>

                          <div className="carousel-item">
                            Lorem Ipsum is simply dummy text of the printing and
                            typesetting industry. Lorem Ipsum has been the industry's
                            standard dummy text ever since the 1500s, when an unknown
                            printer took a galley of type and scrambled it to make a type
                            specimen book.
                          </div>

                          <div className="carousel-item">
                            Lorem Ipsum has been the industry's standard dummy text ever
                            since the 1500s, when an unknown printer took a galley of type
                            and scrambled it to make a type specimen book. It has survived
                            not only five centuries, but also the leap into electronic
                            typesetting, remaining essentially unchanged.
                          </div>
                        </div>
                      </div>*/}

                      <div className="flex-root align-items-center text-center">
                        <span className="fs-2 text-primary fw-bolder pe-2">SERVIÇOS</span>
                      </div>

                      <div className="flex-root align-items-center justify-content-start flex-wrap mb-10">
                        <div className="row">
                          {!branches.listLoading && branch?.id && branch?.attributes?.location && <>
                            {branch?.attributes?.tags?.map((tag, i) => <>

                              {(!seeMoreTags && i < 6 || seeMoreTags) && <div className="min-h-lg-80px col-4 align-items-center d-flex flex-column mt-5">
                                <img
                                  src={toAbsoluteUrl(`/media/custom/${getIcon(tag)}.png`)}
                                  height="48"
                                  width="48"
                                  alt={getTag(tag)}
                                  className="icon-flag menu-hover-primary"
                                />
                                <span className="text-center fs-6 fw-semibold text-gray-600 mt-2 text-hover-primary cursor-default">{getTag(tag)}</span>
                              </div>}
                            </>)}

                            {branch?.attributes?.tags?.length > 6 && <span
                              className="fs-4 mt-4 cursor-pointer text-gray-900 text-hover-primary text-center"
                              onClick={() => setSeeMoreTags(!seeMoreTags)}
                            >
                              {!seeMoreTags && `Ver todos`}
                              {seeMoreTags && `Ver menos`}
                            </span>}
                          </>}

                          {branches.listLoading && !branch?.id && <LoadingSquares />}
                        </div>
                      </div>

                      <div className="flex-root align-items-center text-center mb-5">
                        <span className="fs-2 text-primary fw-bolder pe-2">LOCALIZAÇÃO</span>
                      </div>

                      {!branches.listLoading && branch?.id && branch?.attributes?.location && <iframe
                        height="350"
                        frameBorder="0"
                        className="w-100 border-0"
                        referrerPolicy="no-referrer-when-downgrade"
                        src={`https://maps.google.com/maps?key=AIzaSyCuZHJIuP1knpWXwkLAGIx1VHZPIXS8kT0&q=${branch.attributes.location[0]},${branch.attributes.location[1]}&z=15&output=embed`}
                      ></iframe>}

                      {branches.listLoading && !branch?.id && <LoadingSquare />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>}

    <CheckInDayUseModal
      isOpen={openCheckInDayUseModal}
      onClosed={() => setOpenCheckInDayUseModal(false)}
    />
  </>)
}

export {
  CompanyPage
}
